export const POPULATION_BY_NATIONALITY = [
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche',
    nationalitat: 'Deutschland',
    _2023: 168876,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Alle',
    _2023: 79849,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Europäische Union (EU)',
    _2023: 14036,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Frankreich',
    _2023: 1468,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Griechenland',
    _2023: 841,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Italien',
    _2023: 1126,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Österreich',
    _2023: 619,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Spanien',
    _2023: 684,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Polen',
    _2023: 4795,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Bulgarien',
    _2023: 966,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Rumänien',
    _2023: 681,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Kroatien',
    _2023: 395,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vereinigtes Königreich',
    _2023: 1141,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'ehemaliges Jugoslawien',
    _2023: 3452,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Bosnien und Herzegowina',
    _2023: 770,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Serbien',
    _2023: 1044,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'ehemalige Sowjetunion',
    _2023: 6896,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Russische Föderation',
    _2023: 2775,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Ukraine',
    _2023: 1265,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Kasachstan',
    _2023: 887,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Islamische Länder(OIC) einschl. Syrien',
    _2023: 33024,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Türkei',
    _2023: 14932,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Iran',
    _2023: 1175,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Arabische Länder einschl. Syrien',
    _2023: 12181,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Libanon',
    _2023: 4907,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Syrien',
    _2023: 1818,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vietnam',
    _2023: 1291,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vereinigte Staaten/ USA',
    _2023: 1468,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'nicht eindeutig zuordenbar/ ohne Angabe',
    _2023: 12161,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'Ausländer',
    _2023: 148409,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'Europäische Union (EU)',
    _2023: 45225,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'Frankreich',
    _2023: 3762,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'Griechenland',
    _2023: 2574,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'Italien',
    _2023: 5693,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'Österreich',
    _2023: 1982,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'Spanien',
    _2023: 3160,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'Polen',
    _2023: 6761,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'Bulgarien',
    _2023: 7337,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'Rumänien',
    _2023: 3533,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'Kroatien',
    _2023: 1745,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vereinigtes Königreich',
    _2023: 3007,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'ehemaliges Jugoslawien',
    _2023: 8483,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'Bosnien und Herzegowina',
    _2023: 1938,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'Serbien',
    _2023: 2582,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'ehemalige Sowjetunion',
    _2023: 17165,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'Russische Föderation',
    _2023: 6085,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'Ukraine',
    _2023: 7181,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'Kasachstan',
    _2023: 292,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'Islamische Länder(OIC)einschl. Syrien',
    _2023: 47699,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'Türkei',
    _2023: 21125,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'Iran',
    _2023: 1549,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'Arabische Länder einschl. Syrien',
    _2023: 17107,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'Libanon',
    _2023: 1770,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'Syrien',
    _2023: 5510,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vietnam',
    _2023: 2034,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vereinigte Staaten/ USA',
    _2023: 3805,
  },
  {
    bezirk: 'Mitte',
    bevolkerung: 'Ausländer',
    nationalitat: 'nicht eindeutig zuordenbar/ ohne Angabe',
    _2023: 6,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche',
    nationalitat: 'Deutschland',
    _2023: 150813,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Alle',
    _2023: 53116,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Europäische Union (EU)',
    _2023: 10931,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Frankreich',
    _2023: 1454,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Griechenland',
    _2023: 503,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Italien',
    _2023: 1306,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Österreich',
    _2023: 603,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Spanien',
    _2023: 954,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Polen',
    _2023: 2553,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Bulgarien',
    _2023: 500,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Rumänien',
    _2023: 479,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Kroatien',
    _2023: 256,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vereinigtes Königreich',
    _2023: 1109,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'ehemaliges Jugoslawien',
    _2023: 1440,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Bosnien und Herzegowina',
    _2023: 303,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Serbien',
    _2023: 361,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'ehemalige Sowjetunion',
    _2023: 3733,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Russische Föderation',
    _2023: 1570,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Ukraine',
    _2023: 546,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Kasachstan',
    _2023: 604,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Islamische Länder(OIC) einschl. Syrien',
    _2023: 19355,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Türkei',
    _2023: 10653,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Iran',
    _2023: 750,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Arabische Länder einschl. Syrien',
    _2023: 5853,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Libanon',
    _2023: 2054,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Syrien',
    _2023: 1150,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vietnam',
    _2023: 1317,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vereinigte Staaten/ USA',
    _2023: 1424,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'nicht eindeutig zuordenbar/ ohne Angabe',
    _2023: 8419,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Ausländer',
    _2023: 89525,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Europäische Union (EU)',
    _2023: 29304,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Frankreich',
    _2023: 3605,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Griechenland',
    _2023: 1502,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Italien',
    _2023: 5348,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Österreich',
    _2023: 1653,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Spanien',
    _2023: 2844,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Polen',
    _2023: 2924,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Bulgarien',
    _2023: 2174,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Rumänien',
    _2023: 1234,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Kroatien',
    _2023: 906,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vereinigtes Königreich',
    _2023: 2905,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'ehemaliges Jugoslawien',
    _2023: 3712,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Bosnien und Herzegowina',
    _2023: 991,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Serbien',
    _2023: 963,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'ehemalige Sowjetunion',
    _2023: 8931,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Russische Föderation',
    _2023: 2802,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Ukraine',
    _2023: 4098,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Kasachstan',
    _2023: 113,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Islamische Länder(OIC)einschl. Syrien',
    _2023: 26144,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Türkei',
    _2023: 14825,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Iran',
    _2023: 689,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Arabische Länder einschl. Syrien',
    _2023: 7207,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Libanon',
    _2023: 640,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Syrien',
    _2023: 2715,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vietnam',
    _2023: 2374,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vereinigte Staaten/ USA',
    _2023: 3565,
  },
  {
    bezirk: 'Friedrichshain-Kreuzberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'nicht eindeutig zuordenbar/ ohne Angabe',
    _2023: 3,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche',
    nationalitat: 'Deutschland',
    _2023: 303230,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Alle',
    _2023: 39620,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Europäische Union (EU)',
    _2023: 13591,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Frankreich',
    _2023: 1573,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Griechenland',
    _2023: 459,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Italien',
    _2023: 1265,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Österreich',
    _2023: 837,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Spanien',
    _2023: 881,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Polen',
    _2023: 3877,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Bulgarien',
    _2023: 594,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Rumänien',
    _2023: 610,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Kroatien',
    _2023: 260,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vereinigtes Königreich',
    _2023: 1409,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'ehemaliges Jugoslawien',
    _2023: 1243,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Bosnien und Herzegowina',
    _2023: 198,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Serbien',
    _2023: 326,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'ehemalige Sowjetunion',
    _2023: 6211,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Russische Föderation',
    _2023: 2407,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Ukraine',
    _2023: 779,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Kasachstan',
    _2023: 1076,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Islamische Länder(OIC) einschl. Syrien',
    _2023: 7092,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Türkei',
    _2023: 1649,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Iran',
    _2023: 538,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Arabische Länder einschl. Syrien',
    _2023: 2359,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Libanon',
    _2023: 399,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Syrien',
    _2023: 518,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vietnam',
    _2023: 1125,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vereinigte Staaten/ USA',
    _2023: 1560,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'nicht eindeutig zuordenbar/ ohne Angabe',
    _2023: 2473,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'Ausländer',
    _2023: 81457,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'Europäische Union (EU)',
    _2023: 26155,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'Frankreich',
    _2023: 2691,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'Griechenland',
    _2023: 1103,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'Italien',
    _2023: 4378,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'Österreich',
    _2023: 1635,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'Spanien',
    _2023: 2099,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'Polen',
    _2023: 3538,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'Bulgarien',
    _2023: 1819,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'Rumänien',
    _2023: 1815,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'Kroatien',
    _2023: 628,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vereinigtes Königreich',
    _2023: 2161,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'ehemaliges Jugoslawien',
    _2023: 3111,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'Bosnien und Herzegowina',
    _2023: 612,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'Serbien',
    _2023: 982,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'ehemalige Sowjetunion',
    _2023: 13610,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'Russische Föderation',
    _2023: 4520,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'Ukraine',
    _2023: 5623,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'Kasachstan',
    _2023: 179,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'Islamische Länder(OIC)einschl. Syrien',
    _2023: 18518,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'Türkei',
    _2023: 3564,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'Iran',
    _2023: 1093,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'Arabische Länder einschl. Syrien',
    _2023: 7927,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'Libanon',
    _2023: 315,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'Syrien',
    _2023: 3728,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vietnam',
    _2023: 2027,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vereinigte Staaten/ USA',
    _2023: 3065,
  },
  {
    bezirk: 'Pankow',
    bevolkerung: 'Ausländer',
    nationalitat: 'nicht eindeutig zuordenbar/ ohne Angabe',
    _2023: 7,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche',
    nationalitat: 'Deutschland',
    _2023: 187722,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Alle',
    _2023: 63288,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Europäische Union (EU)',
    _2023: 15074,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Frankreich',
    _2023: 1322,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Griechenland',
    _2023: 875,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Italien',
    _2023: 1406,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Österreich',
    _2023: 744,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Spanien',
    _2023: 786,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Polen',
    _2023: 5344,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Bulgarien',
    _2023: 641,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Rumänien',
    _2023: 738,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Kroatien',
    _2023: 632,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vereinigtes Königreich',
    _2023: 1283,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'ehemaliges Jugoslawien',
    _2023: 2886,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Bosnien und Herzegowina',
    _2023: 460,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Serbien',
    _2023: 803,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'ehemalige Sowjetunion',
    _2023: 9341,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Russische Föderation',
    _2023: 3137,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Ukraine',
    _2023: 2212,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Kasachstan',
    _2023: 886,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Islamische Länder(OIC) einschl. Syrien',
    _2023: 17970,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Türkei',
    _2023: 6036,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Iran',
    _2023: 2797,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Arabische Länder einschl. Syrien',
    _2023: 6003,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Libanon',
    _2023: 1534,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Syrien',
    _2023: 1105,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vietnam',
    _2023: 884,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vereinigte Staaten/ USA',
    _2023: 1739,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'nicht eindeutig zuordenbar/ ohne Angabe',
    _2023: 8004,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Ausländer',
    _2023: 92071,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Europäische Union (EU)',
    _2023: 26135,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Frankreich',
    _2023: 2070,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Griechenland',
    _2023: 1509,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Italien',
    _2023: 3449,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Österreich',
    _2023: 1377,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Spanien',
    _2023: 1407,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Polen',
    _2023: 5317,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Bulgarien',
    _2023: 1849,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Rumänien',
    _2023: 2313,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Kroatien',
    _2023: 1614,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vereinigtes Königreich',
    _2023: 1413,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'ehemaliges Jugoslawien',
    _2023: 6356,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Bosnien und Herzegowina',
    _2023: 1122,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Serbien',
    _2023: 2167,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'ehemalige Sowjetunion',
    _2023: 17939,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Russische Föderation',
    _2023: 5636,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Ukraine',
    _2023: 8919,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Kasachstan',
    _2023: 174,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Islamische Länder(OIC)einschl. Syrien',
    _2023: 21925,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Türkei',
    _2023: 7085,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Iran',
    _2023: 1985,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Arabische Länder einschl. Syrien',
    _2023: 8090,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Libanon',
    _2023: 566,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Syrien',
    _2023: 2849,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vietnam',
    _2023: 906,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vereinigte Staaten/ USA',
    _2023: 2772,
  },
  {
    bezirk: 'Charlottenburg-Wilmersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'nicht eindeutig zuordenbar/ ohne Angabe',
    _2023: 6,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche',
    nationalitat: 'Deutschland',
    _2023: 144541,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Alle',
    _2023: 45596,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Europäische Union (EU)',
    _2023: 9180,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Frankreich',
    _2023: 311,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Griechenland',
    _2023: 259,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Italien',
    _2023: 437,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Österreich',
    _2023: 260,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Spanien',
    _2023: 145,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Polen',
    _2023: 5798,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Bulgarien',
    _2023: 319,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Rumänien',
    _2023: 377,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Kroatien',
    _2023: 360,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vereinigtes Königreich',
    _2023: 609,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'ehemaliges Jugoslawien',
    _2023: 2460,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Bosnien und Herzegowina',
    _2023: 497,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Serbien',
    _2023: 827,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'ehemalige Sowjetunion',
    _2023: 7657,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Russische Föderation',
    _2023: 3279,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Ukraine',
    _2023: 750,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Kasachstan',
    _2023: 2369,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Islamische Länder(OIC) einschl. Syrien',
    _2023: 18217,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Türkei',
    _2023: 7073,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Iran',
    _2023: 1181,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Arabische Länder einschl. Syrien',
    _2023: 5538,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Libanon',
    _2023: 1646,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Syrien',
    _2023: 959,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vietnam',
    _2023: 449,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vereinigte Staaten/ USA',
    _2023: 408,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'nicht eindeutig zuordenbar/ ohne Angabe',
    _2023: 6717,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'Ausländer',
    _2023: 66954,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'Europäische Union (EU)',
    _2023: 19571,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'Frankreich',
    _2023: 306,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'Griechenland',
    _2023: 626,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'Italien',
    _2023: 1277,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'Österreich',
    _2023: 403,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'Spanien',
    _2023: 443,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'Polen',
    _2023: 6527,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'Bulgarien',
    _2023: 3801,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'Rumänien',
    _2023: 2617,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'Kroatien',
    _2023: 1389,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vereinigtes Königreich',
    _2023: 433,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'ehemaliges Jugoslawien',
    _2023: 6736,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'Bosnien und Herzegowina',
    _2023: 1520,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'Serbien',
    _2023: 2251,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'ehemalige Sowjetunion',
    _2023: 9652,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'Russische Föderation',
    _2023: 1972,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'Ukraine',
    _2023: 5314,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'Kasachstan',
    _2023: 200,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'Islamische Länder(OIC)einschl. Syrien',
    _2023: 26164,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'Türkei',
    _2023: 8006,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'Iran',
    _2023: 1299,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'Arabische Länder einschl. Syrien',
    _2023: 10486,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'Libanon',
    _2023: 611,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'Syrien',
    _2023: 5103,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vietnam',
    _2023: 802,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vereinigte Staaten/ USA',
    _2023: 303,
  },
  {
    bezirk: 'Spandau',
    bevolkerung: 'Ausländer',
    nationalitat: 'nicht eindeutig zuordenbar/ ohne Angabe',
    _2023: 0,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche',
    nationalitat: 'Deutschland',
    _2023: 210966,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Alle',
    _2023: 44357,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Europäische Union (EU)',
    _2023: 12850,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Frankreich',
    _2023: 855,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Griechenland',
    _2023: 787,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Italien',
    _2023: 892,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Österreich',
    _2023: 691,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Spanien',
    _2023: 494,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Polen',
    _2023: 5488,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Bulgarien',
    _2023: 421,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Rumänien',
    _2023: 534,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Kroatien',
    _2023: 589,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vereinigtes Königreich',
    _2023: 1137,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'ehemaliges Jugoslawien',
    _2023: 2444,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Bosnien und Herzegowina',
    _2023: 443,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Serbien',
    _2023: 679,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'ehemalige Sowjetunion',
    _2023: 4801,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Russische Föderation',
    _2023: 1805,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Ukraine',
    _2023: 891,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Kasachstan',
    _2023: 661,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Islamische Länder(OIC) einschl. Syrien',
    _2023: 11441,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Türkei',
    _2023: 4091,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Iran',
    _2023: 1682,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Arabische Länder einschl. Syrien',
    _2023: 3600,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Libanon',
    _2023: 862,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Syrien',
    _2023: 693,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vietnam',
    _2023: 397,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vereinigte Staaten/ USA',
    _2023: 1978,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'nicht eindeutig zuordenbar/ ohne Angabe',
    _2023: 4929,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Ausländer',
    _2023: 55123,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Europäische Union (EU)',
    _2023: 15809,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Frankreich',
    _2023: 984,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Griechenland',
    _2023: 1205,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Italien',
    _2023: 1766,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Österreich',
    _2023: 977,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Spanien',
    _2023: 761,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Polen',
    _2023: 3868,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Bulgarien',
    _2023: 983,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Rumänien',
    _2023: 1094,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Kroatien',
    _2023: 1298,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vereinigtes Königreich',
    _2023: 796,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'ehemaliges Jugoslawien',
    _2023: 4302,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Bosnien und Herzegowina',
    _2023: 921,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Serbien',
    _2023: 1238,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'ehemalige Sowjetunion',
    _2023: 9157,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Russische Föderation',
    _2023: 2319,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Ukraine',
    _2023: 4799,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Kasachstan',
    _2023: 97,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Islamische Länder(OIC)einschl. Syrien',
    _2023: 14518,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Türkei',
    _2023: 4053,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Iran',
    _2023: 1371,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Arabische Länder einschl. Syrien',
    _2023: 5335,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Libanon',
    _2023: 330,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Syrien',
    _2023: 2362,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vietnam',
    _2023: 494,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vereinigte Staaten/ USA',
    _2023: 2555,
  },
  {
    bezirk: 'Steglitz-Zehlendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'nicht eindeutig zuordenbar/ ohne Angabe',
    _2023: 3,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche',
    nationalitat: 'Deutschland',
    _2023: 208506,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Alle',
    _2023: 65856,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Europäische Union (EU)',
    _2023: 15566,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Frankreich',
    _2023: 1123,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Griechenland',
    _2023: 716,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Italien',
    _2023: 1196,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Österreich',
    _2023: 562,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Spanien',
    _2023: 550,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Polen',
    _2023: 7397,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Bulgarien',
    _2023: 490,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Rumänien',
    _2023: 663,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Kroatien',
    _2023: 798,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vereinigtes Königreich',
    _2023: 1030,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'ehemaliges Jugoslawien',
    _2023: 3379,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Bosnien und Herzegowina',
    _2023: 495,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Serbien',
    _2023: 997,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'ehemalige Sowjetunion',
    _2023: 6619,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Russische Föderation',
    _2023: 2732,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Ukraine',
    _2023: 970,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Kasachstan',
    _2023: 1303,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Islamische Länder(OIC) einschl. Syrien',
    _2023: 22275,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Türkei',
    _2023: 10614,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Iran',
    _2023: 1181,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Arabische Länder einschl. Syrien',
    _2023: 7307,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Libanon',
    _2023: 2925,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Syrien',
    _2023: 1588,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vietnam',
    _2023: 587,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vereinigte Staaten/ USA',
    _2023: 1350,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'nicht eindeutig zuordenbar/ ohne Angabe',
    _2023: 11350,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Ausländer',
    _2023: 81506,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Europäische Union (EU)',
    _2023: 24040,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Frankreich',
    _2023: 1639,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Griechenland',
    _2023: 1685,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Italien',
    _2023: 3045,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Österreich',
    _2023: 1106,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Spanien',
    _2023: 1147,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Polen',
    _2023: 5173,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Bulgarien',
    _2023: 2298,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Rumänien',
    _2023: 1934,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Kroatien',
    _2023: 2108,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vereinigtes Königreich',
    _2023: 1252,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'ehemaliges Jugoslawien',
    _2023: 7223,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Bosnien und Herzegowina',
    _2023: 1403,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Serbien',
    _2023: 2176,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'ehemalige Sowjetunion',
    _2023: 10587,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Russische Föderation',
    _2023: 2784,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Ukraine',
    _2023: 5448,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Kasachstan',
    _2023: 138,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Islamische Länder(OIC)einschl. Syrien',
    _2023: 28045,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Türkei',
    _2023: 12093,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Iran',
    _2023: 994,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Arabische Länder einschl. Syrien',
    _2023: 10049,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Libanon',
    _2023: 1046,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Syrien',
    _2023: 4239,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vietnam',
    _2023: 639,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vereinigte Staaten/ USA',
    _2023: 1854,
  },
  {
    bezirk: 'Tempelhof-Schöneberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'nicht eindeutig zuordenbar/ ohne Angabe',
    _2023: 12,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche',
    nationalitat: 'Deutschland',
    _2023: 164069,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Alle',
    _2023: 72903,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Europäische Union (EU)',
    _2023: 12721,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Frankreich',
    _2023: 813,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Griechenland',
    _2023: 566,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Italien',
    _2023: 979,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Österreich',
    _2023: 459,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Spanien',
    _2023: 402,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Polen',
    _2023: 6681,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Bulgarien',
    _2023: 411,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Rumänien',
    _2023: 581,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Kroatien',
    _2023: 366,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vereinigtes Königreich',
    _2023: 782,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'ehemaliges Jugoslawien',
    _2023: 4379,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Bosnien und Herzegowina',
    _2023: 616,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Serbien',
    _2023: 1660,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'ehemalige Sowjetunion',
    _2023: 3269,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Russische Föderation',
    _2023: 1204,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Ukraine',
    _2023: 431,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Kasachstan',
    _2023: 796,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Islamische Länder(OIC) einschl. Syrien',
    _2023: 32569,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Türkei',
    _2023: 16846,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Iran',
    _2023: 558,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Arabische Länder einschl. Syrien',
    _2023: 12510,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Libanon',
    _2023: 6547,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Syrien',
    _2023: 1472,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vietnam',
    _2023: 543,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vereinigte Staaten/ USA',
    _2023: 840,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'nicht eindeutig zuordenbar/ ohne Angabe',
    _2023: 14843,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'Ausländer',
    _2023: 93045,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'Europäische Union (EU)',
    _2023: 28178,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'Frankreich',
    _2023: 2093,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'Griechenland',
    _2023: 1574,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'Italien',
    _2023: 3716,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'Österreich',
    _2023: 1116,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'Spanien',
    _2023: 1584,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'Polen',
    _2023: 5270,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'Bulgarien',
    _2023: 3683,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'Rumänien',
    _2023: 2829,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'Kroatien',
    _2023: 1401,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vereinigtes Königreich',
    _2023: 2113,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'ehemaliges Jugoslawien',
    _2023: 8447,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'Bosnien und Herzegowina',
    _2023: 1381,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'Serbien',
    _2023: 2925,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'ehemalige Sowjetunion',
    _2023: 6072,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'Russische Föderation',
    _2023: 1189,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'Ukraine',
    _2023: 3263,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'Kasachstan',
    _2023: 49,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'Islamische Länder(OIC)einschl. Syrien',
    _2023: 38339,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'Türkei',
    _2023: 19907,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'Iran',
    _2023: 636,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'Arabische Länder einschl. Syrien',
    _2023: 13471,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'Libanon',
    _2023: 2698,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'Syrien',
    _2023: 3981,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vietnam',
    _2023: 591,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vereinigte Staaten/ USA',
    _2023: 2101,
  },
  {
    bezirk: 'Neukölln',
    bevolkerung: 'Ausländer',
    nationalitat: 'nicht eindeutig zuordenbar/ ohne Angabe',
    _2023: 6,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche',
    nationalitat: 'Deutschland',
    _2023: 223100,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Alle',
    _2023: 22695,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Europäische Union (EU)',
    _2023: 6625,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Frankreich',
    _2023: 430,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Griechenland',
    _2023: 179,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Italien',
    _2023: 448,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Österreich',
    _2023: 265,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Spanien',
    _2023: 259,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Polen',
    _2023: 2676,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Bulgarien',
    _2023: 309,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Rumänien',
    _2023: 386,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Kroatien',
    _2023: 112,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vereinigtes Königreich',
    _2023: 461,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'ehemaliges Jugoslawien',
    _2023: 1379,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Bosnien und Herzegowina',
    _2023: 323,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Serbien',
    _2023: 534,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'ehemalige Sowjetunion',
    _2023: 4164,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Russische Föderation',
    _2023: 1571,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Ukraine',
    _2023: 520,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Kasachstan',
    _2023: 1088,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Islamische Länder(OIC) einschl. Syrien',
    _2023: 6084,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Türkei',
    _2023: 1798,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Iran',
    _2023: 247,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Arabische Länder einschl. Syrien',
    _2023: 1993,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Libanon',
    _2023: 477,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Syrien',
    _2023: 459,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vietnam',
    _2023: 529,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vereinigte Staaten/ USA',
    _2023: 466,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'nicht eindeutig zuordenbar/ ohne Angabe',
    _2023: 2115,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'Ausländer',
    _2023: 48286,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'Europäische Union (EU)',
    _2023: 13473,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'Frankreich',
    _2023: 620,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'Griechenland',
    _2023: 487,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'Italien',
    _2023: 1370,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'Österreich',
    _2023: 506,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'Spanien',
    _2023: 759,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'Polen',
    _2023: 2957,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'Bulgarien',
    _2023: 1668,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'Rumänien',
    _2023: 2118,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'Kroatien',
    _2023: 447,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vereinigtes Königreich',
    _2023: 579,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'ehemaliges Jugoslawien',
    _2023: 2940,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'Bosnien und Herzegowina',
    _2023: 628,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'Serbien',
    _2023: 1008,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'ehemalige Sowjetunion',
    _2023: 8435,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'Russische Föderation',
    _2023: 2361,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'Ukraine',
    _2023: 3920,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'Kasachstan',
    _2023: 142,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'Islamische Länder(OIC)einschl. Syrien',
    _2023: 15375,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'Türkei',
    _2023: 2867,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'Iran',
    _2023: 774,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'Arabische Länder einschl. Syrien',
    _2023: 7241,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'Libanon',
    _2023: 380,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'Syrien',
    _2023: 3420,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vietnam',
    _2023: 1341,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vereinigte Staaten/ USA',
    _2023: 606,
  },
  {
    bezirk: 'Treptow-Köpenick',
    bevolkerung: 'Ausländer',
    nationalitat: 'nicht eindeutig zuordenbar/ ohne Angabe',
    _2023: 6,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche',
    nationalitat: 'Deutschland',
    _2023: 210457,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Alle',
    _2023: 27261,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Europäische Union (EU)',
    _2023: 4319,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Frankreich',
    _2023: 124,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Griechenland',
    _2023: 89,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Italien',
    _2023: 192,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Österreich',
    _2023: 88,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Spanien',
    _2023: 108,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Polen',
    _2023: 2005,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Bulgarien',
    _2023: 296,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Rumänien',
    _2023: 291,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Kroatien',
    _2023: 58,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vereinigtes Königreich',
    _2023: 135,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'ehemaliges Jugoslawien',
    _2023: 1007,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Bosnien und Herzegowina',
    _2023: 130,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Serbien',
    _2023: 422,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'ehemalige Sowjetunion',
    _2023: 14271,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Russische Föderation',
    _2023: 6514,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Ukraine',
    _2023: 892,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Kasachstan',
    _2023: 5015,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Islamische Länder(OIC) einschl. Syrien',
    _2023: 8937,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Türkei',
    _2023: 778,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Iran',
    _2023: 92,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Arabische Länder einschl. Syrien',
    _2023: 1439,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Libanon',
    _2023: 149,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Syrien',
    _2023: 418,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vietnam',
    _2023: 1915,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vereinigte Staaten/ USA',
    _2023: 93,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'nicht eindeutig zuordenbar/ ohne Angabe',
    _2023: 1201,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Ausländer',
    _2023: 54230,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Europäische Union (EU)',
    _2023: 13627,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Frankreich',
    _2023: 147,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Griechenland',
    _2023: 403,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Italien',
    _2023: 465,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Österreich',
    _2023: 178,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Spanien',
    _2023: 254,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Polen',
    _2023: 3305,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Bulgarien',
    _2023: 1566,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Rumänien',
    _2023: 4744,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Kroatien',
    _2023: 285,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vereinigtes Königreich',
    _2023: 146,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'ehemaliges Jugoslawien',
    _2023: 3097,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Bosnien und Herzegowina',
    _2023: 548,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Serbien',
    _2023: 1266,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'ehemalige Sowjetunion',
    _2023: 12653,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Russische Föderation',
    _2023: 2718,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Ukraine',
    _2023: 5243,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Kasachstan',
    _2023: 435,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Islamische Länder(OIC)einschl. Syrien',
    _2023: 18091,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Türkei',
    _2023: 1482,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Iran',
    _2023: 668,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Arabische Länder einschl. Syrien',
    _2023: 8612,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Libanon',
    _2023: 111,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Syrien',
    _2023: 4661,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vietnam',
    _2023: 4972,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vereinigte Staaten/ USA',
    _2023: 123,
  },
  {
    bezirk: 'Marzahn-Hellersdorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'nicht eindeutig zuordenbar/ ohne Angabe',
    _2023: 3,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche',
    nationalitat: 'Deutschland',
    _2023: 203862,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Alle',
    _2023: 32073,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Europäische Union (EU)',
    _2023: 5751,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Frankreich',
    _2023: 313,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Griechenland',
    _2023: 171,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Italien',
    _2023: 300,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Österreich',
    _2023: 207,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Spanien',
    _2023: 219,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Polen',
    _2023: 2230,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Bulgarien',
    _2023: 503,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Rumänien',
    _2023: 312,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Kroatien',
    _2023: 89,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vereinigtes Königreich',
    _2023: 320,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'ehemaliges Jugoslawien',
    _2023: 1984,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Bosnien und Herzegowina',
    _2023: 312,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Serbien',
    _2023: 690,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'ehemalige Sowjetunion',
    _2023: 10814,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Russische Föderation',
    _2023: 4659,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Ukraine',
    _2023: 908,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Kasachstan',
    _2023: 3340,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Islamische Länder(OIC) einschl. Syrien',
    _2023: 9032,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Türkei',
    _2023: 1159,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Iran',
    _2023: 229,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Arabische Länder einschl. Syrien',
    _2023: 2430,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Libanon',
    _2023: 285,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Syrien',
    _2023: 664,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vietnam',
    _2023: 3343,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vereinigte Staaten/ USA',
    _2023: 326,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'nicht eindeutig zuordenbar/ ohne Angabe',
    _2023: 2127,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Ausländer',
    _2023: 75946,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Europäische Union (EU)',
    _2023: 16908,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Frankreich',
    _2023: 729,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Griechenland',
    _2023: 673,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Italien',
    _2023: 1636,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Österreich',
    _2023: 415,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Spanien',
    _2023: 852,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Polen',
    _2023: 3652,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Bulgarien',
    _2023: 2386,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Rumänien',
    _2023: 2759,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Kroatien',
    _2023: 571,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vereinigtes Königreich',
    _2023: 511,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'ehemaliges Jugoslawien',
    _2023: 5187,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Bosnien und Herzegowina',
    _2023: 1035,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Serbien',
    _2023: 1913,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'ehemalige Sowjetunion',
    _2023: 12747,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Russische Föderation',
    _2023: 3490,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Ukraine',
    _2023: 5265,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Kasachstan',
    _2023: 305,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Islamische Länder(OIC)einschl. Syrien',
    _2023: 23869,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Türkei',
    _2023: 2370,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Iran',
    _2023: 1035,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Arabische Länder einschl. Syrien',
    _2023: 12414,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Libanon',
    _2023: 279,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Syrien',
    _2023: 6367,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vietnam',
    _2023: 9109,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vereinigte Staaten/ USA',
    _2023: 571,
  },
  {
    bezirk: 'Lichtenberg',
    bevolkerung: 'Ausländer',
    nationalitat: 'nicht eindeutig zuordenbar/ ohne Angabe',
    _2023: 7,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche',
    nationalitat: 'Deutschland',
    _2023: 164014,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Alle',
    _2023: 44961,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Europäische Union (EU)',
    _2023: 9852,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Frankreich',
    _2023: 673,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Griechenland',
    _2023: 331,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Italien',
    _2023: 622,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Österreich',
    _2023: 259,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Spanien',
    _2023: 252,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Polen',
    _2023: 5620,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Bulgarien',
    _2023: 305,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Rumänien',
    _2023: 390,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Kroatien',
    _2023: 397,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vereinigtes Königreich',
    _2023: 382,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'ehemaliges Jugoslawien',
    _2023: 2560,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Bosnien und Herzegowina',
    _2023: 562,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Serbien',
    _2023: 677,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'ehemalige Sowjetunion',
    _2023: 4066,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Russische Föderation',
    _2023: 1748,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Ukraine',
    _2023: 481,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Kasachstan',
    _2023: 1008,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Islamische Länder(OIC) einschl. Syrien',
    _2023: 17753,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Türkei',
    _2023: 8746,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Iran',
    _2023: 674,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Arabische Länder einschl. Syrien',
    _2023: 5118,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Libanon',
    _2023: 1628,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Syrien',
    _2023: 726,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vietnam',
    _2023: 610,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vereinigte Staaten/ USA',
    _2023: 459,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'nicht eindeutig zuordenbar/ ohne Angabe',
    _2023: 7554,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Ausländer',
    _2023: 59817,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Europäische Union (EU)',
    _2023: 17984,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Frankreich',
    _2023: 838,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Griechenland',
    _2023: 978,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Italien',
    _2023: 1589,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Österreich',
    _2023: 475,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Spanien',
    _2023: 499,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Polen',
    _2023: 4807,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Bulgarien',
    _2023: 3692,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Rumänien',
    _2023: 1853,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Kroatien',
    _2023: 1093,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vereinigtes Königreich',
    _2023: 383,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'ehemaliges Jugoslawien',
    _2023: 5704,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Bosnien und Herzegowina',
    _2023: 1342,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Serbien',
    _2023: 1834,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'ehemalige Sowjetunion',
    _2023: 7060,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Russische Föderation',
    _2023: 1939,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Ukraine',
    _2023: 3422,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Kasachstan',
    _2023: 94,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Islamische Länder(OIC)einschl. Syrien',
    _2023: 23761,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Türkei',
    _2023: 9645,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Iran',
    _2023: 811,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Arabische Länder einschl. Syrien',
    _2023: 8365,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Libanon',
    _2023: 638,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Syrien',
    _2023: 3366,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vietnam',
    _2023: 562,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vereinigte Staaten/ USA',
    _2023: 423,
  },
  {
    bezirk: 'Reinickendorf',
    bevolkerung: 'Ausländer',
    nationalitat: 'nicht eindeutig zuordenbar/ ohne Angabe',
    _2023: 3,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche',
    nationalitat: 'Deutschland',
    _2023: 2340156,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Alle',
    _2023: 591575,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Europäische Union (EU)',
    _2023: 130496,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Frankreich',
    _2023: 10459,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Griechenland',
    _2023: 5776,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Italien',
    _2023: 10169,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Österreich',
    _2023: 5594,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Spanien',
    _2023: 5734,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Polen',
    _2023: 54464,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Bulgarien',
    _2023: 5755,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Rumänien',
    _2023: 6042,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Kroatien',
    _2023: 4312,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vereinigtes Königreich',
    _2023: 9798,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'ehemaliges Jugoslawien',
    _2023: 28613,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Bosnien und Herzegowina',
    _2023: 5109,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Serbien',
    _2023: 9020,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'ehemalige Sowjetunion',
    _2023: 81842,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Russische Föderation',
    _2023: 33401,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Ukraine',
    _2023: 10645,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Kasachstan',
    _2023: 19033,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Islamische Länder(OIC) einschl. Syrien',
    _2023: 203749,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Türkei',
    _2023: 84375,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Iran',
    _2023: 11104,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Arabische Länder einschl. Syrien',
    _2023: 66331,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Libanon',
    _2023: 23413,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Syrien',
    _2023: 11570,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vietnam',
    _2023: 12990,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'Vereinigte Staaten/ USA',
    _2023: 12111,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Deutsche mit Migrationshintergrund',
    nationalitat: 'nicht eindeutig zuordenbar/ ohne Angabe',
    _2023: 81893,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'Ausländer',
    _2023: 946369,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'Europäische Union (EU)',
    _2023: 276409,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'Frankreich',
    _2023: 19484,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'Griechenland',
    _2023: 14319,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'Italien',
    _2023: 33732,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'Österreich',
    _2023: 11823,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'Spanien',
    _2023: 15809,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'Polen',
    _2023: 54099,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'Bulgarien',
    _2023: 33256,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'Rumänien',
    _2023: 28843,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'Kroatien',
    _2023: 13485,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vereinigtes Königreich',
    _2023: 15699,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'ehemaliges Jugoslawien',
    _2023: 65298,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'Bosnien und Herzegowina',
    _2023: 13441,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'Serbien',
    _2023: 21305,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'ehemalige Sowjetunion',
    _2023: 134008,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'Russische Föderation',
    _2023: 37815,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'Ukraine',
    _2023: 62495,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'Kasachstan',
    _2023: 2218,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'Islamische Länder(OIC)einschl. Syrien',
    _2023: 302448,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'Türkei',
    _2023: 107022,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'Iran',
    _2023: 12904,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'Arabische Länder einschl. Syrien',
    _2023: 116304,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'Libanon',
    _2023: 9384,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'Syrien',
    _2023: 48301,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vietnam',
    _2023: 25851,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'Vereinigte Staaten/ USA',
    _2023: 21743,
  },
  {
    bezirk: 'Berlin',
    bevolkerung: 'Ausländer',
    nationalitat: 'nicht eindeutig zuordenbar/ ohne Angabe',
    _2023: 62,
  },
]
